var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "MuniTransferDocs" },
    [
      _c("p", { staticClass: "hint" }, [
        _vm._v(
          ' מגדיר אילו מסמכים נדרשים בהסבת פרימיום עבור עיריות שאינן מוגדרות ברשימת "עיריות הסבה מינימלית". לכל קבוצת מסמכים: אופציונלי / חובה / לא בשימוש, בנפרד ללקוח ולתייר. '
        )
      ]),
      _c("b-input", {
        staticClass: "search",
        attrs: {
          icon: "magnify",
          "icon-right": _vm.search ? "close-circle" : "",
          "icon-right-clickable": "",
          placeholder: "חיפוש עיריה..."
        },
        on: {
          "icon-right-click": function($event) {
            _vm.search = ""
          }
        },
        model: {
          value: _vm.search,
          callback: function($$v) {
            _vm.search = $$v
          },
          expression: "search"
        }
      }),
      _c(
        "b-table",
        {
          attrs: {
            data: _vm.filteredRows,
            bordered: true,
            striped: true,
            narrowed: true,
            hoverable: false,
            loading: _vm.isLoading,
            "sticky-header": true
          },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function() {
                return [
                  _c("div", { staticClass: "has-text-centered" }, [
                    _vm._v(_vm._s(_vm.emptyMessage))
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-table-column", {
            attrs: { centered: "", field: "MunicipalityName", label: "עיריה" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm._v(" " + _vm._s(props.row.MunicipalityName) + " ")
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { centered: "", label: "תצהיר (לקוח)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "b-select",
                      {
                        model: {
                          value: props.row.ClientDeclaration,
                          callback: function($$v) {
                            _vm.$set(props.row, "ClientDeclaration", $$v)
                          },
                          expression: "props.row.ClientDeclaration"
                        }
                      },
                      _vm._l(_vm.requirementOptions, function(o) {
                        return _c(
                          "option",
                          { key: o.value, domProps: { value: o.value } },
                          [_vm._v(_vm._s(o.label))]
                        )
                      }),
                      0
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { centered: "", label: "מסמכי חוזה (לקוח)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "b-select",
                      {
                        model: {
                          value: props.row.ClientContractForms,
                          callback: function($$v) {
                            _vm.$set(props.row, "ClientContractForms", $$v)
                          },
                          expression: "props.row.ClientContractForms"
                        }
                      },
                      _vm._l(_vm.requirementOptions, function(o) {
                        return _c(
                          "option",
                          { key: o.value, domProps: { value: o.value } },
                          [_vm._v(_vm._s(o.label))]
                        )
                      }),
                      0
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { centered: "", label: "מסמך מזהה (לקוח)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "b-select",
                      {
                        model: {
                          value: props.row.ClientIdentityDocument,
                          callback: function($$v) {
                            _vm.$set(props.row, "ClientIdentityDocument", $$v)
                          },
                          expression: "props.row.ClientIdentityDocument"
                        }
                      },
                      _vm._l(_vm.requirementOptions, function(o) {
                        return _c(
                          "option",
                          { key: o.value, domProps: { value: o.value } },
                          [_vm._v(_vm._s(o.label))]
                        )
                      }),
                      0
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { centered: "", label: "תצהיר (תייר)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "b-select",
                      {
                        model: {
                          value: props.row.TouristDeclaration,
                          callback: function($$v) {
                            _vm.$set(props.row, "TouristDeclaration", $$v)
                          },
                          expression: "props.row.TouristDeclaration"
                        }
                      },
                      _vm._l(_vm.requirementOptions, function(o) {
                        return _c(
                          "option",
                          { key: o.value, domProps: { value: o.value } },
                          [_vm._v(_vm._s(o.label))]
                        )
                      }),
                      0
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { centered: "", label: "מסמכי חוזה (תייר)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "b-select",
                      {
                        model: {
                          value: props.row.TouristContractForms,
                          callback: function($$v) {
                            _vm.$set(props.row, "TouristContractForms", $$v)
                          },
                          expression: "props.row.TouristContractForms"
                        }
                      },
                      _vm._l(_vm.requirementOptions, function(o) {
                        return _c(
                          "option",
                          { key: o.value, domProps: { value: o.value } },
                          [_vm._v(_vm._s(o.label))]
                        )
                      }),
                      0
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { centered: "", label: "מסמך מזהה (תייר)" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "b-select",
                      {
                        model: {
                          value: props.row.TouristIdentityDocument,
                          callback: function($$v) {
                            _vm.$set(props.row, "TouristIdentityDocument", $$v)
                          },
                          expression: "props.row.TouristIdentityDocument"
                        }
                      },
                      _vm._l(_vm.requirementOptions, function(o) {
                        return _c(
                          "option",
                          { key: o.value, domProps: { value: o.value } },
                          [_vm._v(_vm._s(o.label))]
                        )
                      }),
                      0
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { centered: "", label: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "div",
                      { staticClass: "row-actions" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              loading: props.row.isSaving,
                              type: "is-primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.save(props.row)
                              }
                            }
                          },
                          [_vm._v("שמור")]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              loading: props.row.isDeleting,
                              type: "is-danger"
                            },
                            on: {
                              click: function($event) {
                                return _vm.remove(props.row)
                              }
                            }
                          },
                          [_vm._v("מחק")]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "add-row" },
        [
          _c(
            "b-field",
            { staticClass: "add-municipality", attrs: { label: "הוסף עיריה" } },
            [
              _c("FieldInlineSelect", {
                attrs: {
                  "hide-hover": true,
                  clearable: true,
                  filterable: true,
                  "null-is-value": true,
                  placeholder: "בחר עיריה",
                  optionsAsync: _vm.getMunicipalities,
                  reduce: function(municipality) {
                    return municipality
                  }
                },
                model: {
                  value: _vm.newMunicipality,
                  callback: function($$v) {
                    _vm.newMunicipality = $$v
                  },
                  expression: "newMunicipality"
                }
              })
            ],
            1
          ),
          _c(
            "b-button",
            {
              attrs: {
                loading: _vm.isAdding,
                disabled: !_vm.newMunicipality || !_vm.newMunicipality.Value,
                type: "is-primary"
              },
              on: { click: _vm.add }
            },
            [_vm._v(" הוסף ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }